<h2 rds-dialog-header>{{noAccessConstant.dialogHeaderText}}</h2>
<div rds-dialog-content class="noa">
    {{noAccessConstant.dialogContentText}}
</div>
<div rds-dialog-actions-container>
    <a *ngIf="noAccessConstant?.accessHyperLink" [href]="noAccessConstant.accessHyperLink"><button rds-primary-button
            size="s">{{noAccessConstant.accessLinkText}}</button></a>

    <button rds-primary-button *ngIf="data && data?.['displayFor'] === 'access_denied' && !navigateBack"
        (click)="navigateToProjectListing()">
        <rds-icon namespace="filled" icon="arrow_left" />
        Back to Study Design Hub
    </button>

    <button rds-primary-button *ngIf="data && data?.['displayFor'] === 'access_denied' && navigateBack"
        (click)="goBackToProject()">
        <rds-icon namespace="filled" icon="arrow_left" />
        Back to Project
    </button>
</div>